// extracted by mini-css-extract-plugin
export default {"project":"Project_project__A5CWV","projectDesc":"Project_projectDesc__uMtNi","site":"Project_site__Svt1E","deliverables":"Project_deliverables__Ifoum"};